import React from 'react';
import RoadmapMap from '../components/roadmap/RoadmapMap';

const Roadmap = () => {
  return (
    <div className="roadmap-page">
      <main className="roadmap-main">
        <div className="roadmap-container">
          <div className="roadmap-hero">
            <h1 className="roadmap-hero-title">Roadmap</h1>
            <p className="roadmap-hero-subtitle">
              A tiny map of where we've been and where we're going.
            </p>
          </div>

          <section aria-label="Roadmap map view" className="roadmap-map-section">
            <RoadmapMap />
          </section>
        </div>
      </main>
    </div>
  );
};

export default Roadmap;


